import React, { useState, useEffect } from 'react'
import EmployerDashboardNav from '../../employer/EmployerDashboardNav'
import ProfileViewGraph from '../../candidate/ProfileViewGraph'
import EmployerNotifications from '../../employer/EmployerNotifications'
// import RecentApllications from '../../employer/RecentApplications'
import axios from 'axios'
import RecentApplications from "../../employer/RecentApplications"
import Loader from '../../Loader';
import Breadcrumb from '../../Breadcrumb'

const EmployerDashboard = () => {


  const [postedjobscount,setPostedjobsCount]=useState(null);
  const [totalApplications, setTotalApplications] = useState(0);
  const [loading, setLoading] = useState(true);
  const companyID=localStorage.getItem('companyId');
  const APIurl=`${process.env.REACT_APP_API_URL}jobs/jobscount/${companyID}`;
  const totalApplicationsApiUrl = `${process.env.REACT_APP_API_URL}job_application/totalapplicationscount`;
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [jobsResponse, applicationsResponse] = await Promise.all([
          axios.get(APIurl),
          axios.get(totalApplicationsApiUrl)
        ]);
  
        setPostedjobsCount(jobsResponse.data.PostedJobsCount);
        setTotalApplications(applicationsResponse.data.totalApplications);
      } catch (error) {
        console.log("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [APIurl, totalApplicationsApiUrl]);
  
  return (
    <>
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Dashboard</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Dashboard</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Dashboard"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Dashboard", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <EmployerDashboardNav />
            {/* here page will is design */}
            <div className="col-lg-9">
              <div className="user-profile-wrapper">
                <div className="row">
                  <div className="col-md-6 col-lg-4">
                    <div className="dashboard-widget dashboard-widget-color-1">
                      <div className="dashboard-widget-info">
                        <h1>{postedjobscount?postedjobscount:0}</h1>
                        <span>Posted Jobs</span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <i className="fal fa-briefcase" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="dashboard-widget dashboard-widget-color-2">
                      <div className="dashboard-widget-info">
                        <h1>25k</h1>
                        <span>Profile Views</span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <i className="fal fa-eye" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="dashboard-widget dashboard-widget-color-3">
                      <div className="dashboard-widget-info">
                        <h1>{totalApplications}</h1>
                        <span>Total Application</span>
                      </div>
                      <div className="dashboard-widget-icon">
                        <i className="fal fa-layer-group" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                <ProfileViewGraph/>
                <EmployerNotifications/>
                <div className="col-lg-12">
                  <div className="user-profile-card">
                  <h4 className="user-profile-card-title">Recent Applications</h4>
                  <div className="user-profile-job row">
                  {loading ? (
                          <Loader />
                        ) : totalApplications > 0 ? (
                          <RecentApplications companyId={companyID} />
                        ) : (
                          <p>No recent applications found.</p>
                        )}
                  </div>
                  </div>
                </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployerDashboard